'use client';

import { useQueryClient } from '@tanstack/react-query';
import { CART_QUERY_KEY } from '../constants';

export function useClearCartCache() {
  const queryClient = useQueryClient();

  return {
    clearCartCache: () => {
      queryClient.invalidateQueries({ queryKey: [CART_QUERY_KEY] });
    },
  };
}
